import React from "react";
import { ChevronDown } from "lucide-react";
import "./AdminFields.css";

export function CustomSearchableSelect({
  label,
  options,
  value,
  onChange,
  placeholder = "Select an option",
  error = "",
  required = false,
}) {
  const [isOpen, setIsOpen] = React.useState(false);
  const [searchTerm, setSearchTerm] = React.useState("");
  const dropdownRef = React.useRef(null);

  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const selectedOption = options.find((opt) => opt.value === value);

  React.useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm("");
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="custom-searchable-select" ref={dropdownRef}>
      <label>{label}</label>
      <div
        className={`select-display ${isOpen ? "active" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="selected-value">
          {selectedOption ? selectedOption.label : placeholder}
        </div>
        <ChevronDown
          size={16}
          className={`dropdown-arrow ${isOpen ? "open" : ""}`}
        />
      </div>

      <select
        required={required}
        value={value || ""}
        onChange={() => { }}
        style={{
          opacity: 0,
          position: "absolute",
          bottom: 0,
          left: "50%",
          height: 0,
          width: 0,
          zIndex: -1,
          pointerEvents: "none",
        }}
      >
        <option value="">{placeholder}</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>

      {isOpen && (
        <div className="select-dropdown-menu">
          <div className="select-search-container">
            <input
              autoFocus
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
          <div className="options-list">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option) => (
                <div
                  key={option.value}
                  className={`option-item ${value === option.value ? "selected" : ""}`}
                  onClick={() => {
                    onChange({ target: { value: option.value } });
                    setIsOpen(false);
                    setSearchTerm("");
                  }}
                >
                  {option.label}
                </div>
              ))
            ) : (
              <div className="no-options">No results found</div>
            )}
          </div>
        </div>
      )}
      {error && <span className="error-message">{error}</span>}
    </div>
  );
}

export function ToggleSwitch({ checked, onChange, label }) {
  return (
    <div className="toggle-wrapper">
      {label && <span className="toggle-label">{label}</span>}

      <label className="toggle-switch">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className="slider"></span>
      </label>
    </div>
  );
}
